
<v-dialog persistent v-model="dialog" content-class="bg-white font-lato p-4" max-width="800"  >
  <div class="d-flex align-items-center justify-content-between overflow-auto mb-6" style="row-gap: 0.8rem">
    <h4 class="mb-0">Upload File</h4>
    <v-btn @click="closeModal()" icon>
      <v-icon>mdi-close</v-icon>
    </v-btn>
  </div>
  <div class="d-flex flex-column">
    <Dropzone @files-dropped="addFiles" @files-selected="addFiles" :disabled="files.length >= 10"/>
    <FileList :files="files" :removeFile="removeFile" :getProgressColor="getProgressColor" />
    <CasesSelector :addToCase="addToCase" :casesLoading="casesLoading" :cases="caseItems" :selectedCase="selectedCase"
      :allCasesLoaded="allCasesLoaded" @search-query-change="onSearchQueryChange" @load-more="loadMoreCases"
      @toggle-selection="toggleSelection" @select-case="handleSelectCase" />
  </div>
  <div class="buttons d-flex justify-content-end mt-4">
    <div class="btn btn-outline-primary mr-2" @click="closeModal()">
      Cancel
    </div>
    <button type="submit" class="btn btn-primary" :disabled="isSaveDisabled || isUploading" @click="saveFiles">
      <span v-if="isUploading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
      <span>{{ isUploading ? 'Uploading ...' : 'Upload' }}</span>
    </button>
  </div>
</v-dialog>
